export default function processesDirective() {
  return {
    template: require('./processes.html'),
    scope: {
      customerId: '<',
      assessment: '=',
    },
    controller: 'PRAProcessesController',
    controllerAs: 'processesVM',
    bindToController: true,
    replace: true,
  };
}
